import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import CustomLink from '../CustomLink';
import { Logo } from '../Logo';
import { SUPPORT_EMAIL } from '../../shared/links';
import logoMemorySrc from '../../assets/images/boundly-logo-memory-light.png';
import styles from './FooterV2.css';

const cx = classnames.bind(styles);

function FooterV2({ className, legalEntity, legalLinks, termsOfUseLabel = 'Terms of Use', privacyPolicyLabel = 'Privacy Policy', cookiePolicyLabel = 'Cookie Policy', logoSrc = logoMemorySrc }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <footer className={classes}>
            <div className={styles.wrapper}>
                <ul className={cx('links', 'bottomDivider')}>
                    <li>
                        <CustomLink
                            to={legalLinks.termsOfUse}
                            target='_blank'
                            className={styles.link}
                        >
                            {termsOfUseLabel}
                        </CustomLink>
                    </li>
                    <li>
                        <CustomLink
                            to={legalLinks.privacyPolicy}
                            target='_blank'
                            className={styles.link}
                        >
                            {privacyPolicyLabel}
                        </CustomLink>
                    </li>
                    <li>
                        <CustomLink
                            to={legalLinks.cookiePolicy}
                            target='_blank'
                            className={styles.link}
                        >
                            {cookiePolicyLabel}
                        </CustomLink>
                    </li>
                </ul>
                <div className={styles.bottomWrapper}>
                    <Logo url={window.location.href} src={logoSrc} />
                    <div>
                        <address className={styles.address} style={{ marginBottom: 16 }}>
                            © {legalEntity.year} — {new Date().getFullYear()} {legalEntity.company} <br /> {legalEntity.address}
                        </address>
                        <ul className={styles.links}>
                            {Boolean(legalEntity.telephone) && (
                                <li>
                                    <CustomLink
                                        to={legalEntity.telephone.link}
                                        target='_blank'
                                        className={styles.link}
                                    >
                                        {legalEntity.telephone.text}
                                    </CustomLink>
                                </li>
                            )}
                            <li>
                                <CustomLink
                                    to={`mailto:${SUPPORT_EMAIL}`}
                                    target='_blank'
                                    className={styles.link}
                                >
                                    {SUPPORT_EMAIL}
                                </CustomLink>
                            </li>
                        </ul>
                    </div>
                    <div className={styles.separator} />
                </div>
            </div>
        </footer>
    );
}

FooterV2.propTypes = {
    className: PropTypes.string,
    legalEntity: PropTypes.shape({
        year: PropTypes.number,
        company: PropTypes.string,
        address: PropTypes.string,
        telephone: PropTypes.shape({
            link: PropTypes.string,
            text: PropTypes.string
        })
    }).isRequired,
    legalLinks: PropTypes.shape({
        termsOfUse: PropTypes.string,
        privacyPolicy: PropTypes.string,
        cookiePolicy: PropTypes.string
    }).isRequired,
    termsOfUseLabel: PropTypes.node,
    privacyPolicyLabel: PropTypes.node,
    cookiePolicyLabel: PropTypes.node,
    logoSrc: PropTypes.string
};

FooterV2.defaultProps = {
    className: ''
};

export {
    FooterV2
};
